import { Component, OnInit } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { CorporateAccountService, GeneralService, IUser } from '@clooper/core';
import { BsModalRef, ModalOptions } from 'ngx-bootstrap/modal';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-extra-service-travel',
  templateUrl: './extra-service-travel.component.html',
  styleUrls: ['./extra-service-travel.component.scss']
})
export class ExtraServiceTravelComponent implements OnInit {
  user: IUser | undefined

  form = new FormGroup({
    arrival_airport: new FormControl('', [Validators.required]),
    departure_airport: new FormControl('', [Validators.required]),
    destination: new FormControl('', [Validators.required]),
    number_of_travelers: new FormControl(0, [Validators.required]),
    additional_requests: new FormControl('', []),
    vehicle_type: new FormControl('', [Validators.required]),
  });
  locationName: any;
  booking: any;

  loading: boolean = false

  constructor(
    public bsModalRef: BsModalRef,
    private options: ModalOptions,
    private service: CorporateAccountService,
    private toastr: ToastrService,
    private gs: GeneralService,


  ) { }

  ngOnInit(): void {
    this.user = this.options.initialState?.user as IUser

    this.booking = this.options.initialState?.booking

  }

  locationChangeF({ latlng, s }: any) {
    // const location = latlng.join(',')
    this.locationName = s;
    console.log(s)
    this.form.controls.arrival_airport.setValue(s);

  }

  locationChangeT({ latlng, s }: any) {
    // const location = latlng.join(',')
    this.locationName = s;
    this.form.controls.departure_airport.setValue(s);

  }

  locationChangeJ({ latlng, s }: any) {
    // const location = latlng.join(',')
    this.locationName = s;
    this.form.controls.destination.setValue(s);

  }

  submit() {
    this.loading = true
    const {arrival_airport, departure_airport, additional_requests, number_of_travelers, destination, vehicle_type} = this.form.value;

    const payload = {
      arrival_airport,
      departure_airport,
      additional_requests,
      number_of_travelers,
      destination,
      vehicle_type,
      employee: this.user?.id || this.user?._id,
      business: this.user?.business?.id || this.user?.business?._id,
      booking: this.booking

    }
    if (this.booking !== null) {
      this.service.createExtraServiceAirportTransfer(payload).subscribe((res: any) => {
          this.toastr.success(res.message)
          this.bsModalRef.hide()
      }, err => {
        this.toastr.error(this.gs.getErrMsg(err));
          // this.bsModalRef.hide()
          this.loading = false

      })
    } else {
      delete payload.booking

      this.service.createExtraServiceAirportTransfer(payload).subscribe((res: any) => {
          this.toastr.success(res.message)
          this.bsModalRef.hide()
      }, err => {
        this.toastr.error(this.gs.getErrMsg(err));
        this.loading = false

          // this.bsModalRef.hide()
      })
    }
  }


}
